import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { format, fromUnixTime } from 'date-fns'
import { PrismicRichText } from '@prismicio/react'

const createStars = (starRating) => {
  let stars = []
  for (let i = 0; i < starRating; i++) {
    stars.push(
      <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 24 24' key={`star-${i}`} className='inline-block w-8'>
        <title>Star</title>
        <path d='M0 0h24v24H0z' fill='none' />
        <path d='M0 0h24v24H0z' fill='none' />
        <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' />
      </svg>
    )
  }
  return stars
}

export default function Reviews({ slice }) {
  const data = useStaticQuery(graphql`
    query googlePlacesQuery {
      allGooglePlacesReview(filter: { rating: { eq: 5 } }, limit: 3, sort: { time: DESC }) {
        nodes {
          author_name
          rating
          text
          time
          id
        }
      }
      googlePlacesPlace {
        place_id
        rating
        user_ratings_total
      }
    }
  `)

  const googlePlace = data.googlePlacesPlace
  return (
    <section className='max-w-screen-xl mx-auto py-10 space-y-6'>
      <div className='space-y-4 px-8 xl:px-0'>
        <PrismicRichText field={slice.primary.title.richText} />
        <div className='text-lg'>
          <PrismicRichText field={slice.primary.description.richText} />
        </div>
      </div>
      <ul className={`component-reviews grid md:grid-cols-3 gap-x-4 gap-y-0.5 md:gap-y-4`}>
        {data.allGooglePlacesReview.nodes.map((review, index) => {
          let reviewDate = format(fromUnixTime(review.time), 'do MMMM yyyy')
          return (
            <li className='bg-gray-800 dark:bg-gray-700 flex flex-col p-8 rounded-sm shadow-sm text-white' key={`review-${index}`}>
              <div className='mb-4 text-fuchsia-400'>{createStars(review.rating)}</div>
              <blockquote className='block prose prose-invert mb-4'>{review.text}</blockquote>
              <div className='mt-auto border-t border-gray-600 pt-4'>
                <span className='text-xl font-serif tracking-tight'>{review.author_name}</span>
                <span className='text-sm'> - {reviewDate}</span>
              </div>
            </li>
          )
        })}
      </ul>
      {slice.primary.show_total && (
        <p className='prose dark:prose-invert px-8 xl:px-0 xl:text-right min-w-full'>
          <span className='font-semibold'>{googlePlace.rating.toFixed(1)}</span>
          <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 24 24' className='text-fuchsia-400 inline-block -mt-1 w-4 mr-1'>
            <title>Star</title>
            <path d='M0 0h24v24H0z' fill='none' />
            <path d='M0 0h24v24H0z' fill='none' />
            <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' />
          </svg>
          from
          {` `}
          <a target='_blank' rel='noopener noreferrer' href={`https://search.google.com/local/writereview?placeid=${googlePlace.place_id}`} className='underline'>
            {googlePlace.user_ratings_total} Google reviews
          </a>
        </p>
      )}
    </section>
  )
}
